export const TITLE_TRATAMENTO_SPREADS = "Tratamento Spreads"

export const WORKFLOW_TABS = [
    { value: "corp", label: "Curvas CORP", content: null },
    { value: "if", label: "Curvas IF", content: null },
]

export const WORKFLOW_OPTIONS = {
    corp: {
        label: "CORP",
        verticesLabel: "Arquivo de vértices",
        resumoLabel: "Arquivo de resumo",
    },
    if: {
        label: "IF",
        verticesLabel: "Arquivo de vértices",
        resumoLabel: "Arquivo de resumo",
    },
}

export const STATUS_VIEW = {
    PENDING: { label: "Pendente", color: "#D29F09", progress: 5 },
    SETUP_TASK: { label: "Setup", color: "#24346C", progress: 15 },
    READY_TO_CALCULATE: { label: "Pronto", color: "#24346C", progress: 30 },
    CALCULATING: { label: "Calculando", color: "#D29F09", progress: 65 },
    REPORT_IN_PROGRESS: { label: "Gerando saída", color: "#D29F09", progress: 85 },
    REPORT_DONE: { label: "Concluído", color: "#2BCE95", progress: 100 },
    ERROR: { label: "Erro", color: "#E01D1D", progress: 100 },
}

export const getStatusView = (status) => (
    STATUS_VIEW[status] || { label: status || "Não informado", color: "#FFFFFF4D", progress: 0 }
)
